export const formatDate = (rawDate) => {
  if (!rawDate) {
    return '';
  }
  const date = new Date(rawDate);
  const locale = 'en-US';
  const result = Intl.DateTimeFormat(locale).format(date);
  return result;
};
